<template>
    <div>
        <h4>
            Удалить кейс {{ delData.name.ru }} № {{ delData.id }}?
        </h4>
        <button 
            class="btn btn-danger" 
            style="position: absolute; bottom: 10px;"
            @click="deleteCase"
        >
            подтвердить
        </button>
    </div>
</template>

<script>
import Data from '../../API';
export default {
    props: ['delData'],
    data() {
        return {

        }
    },
    methods: {
        deleteCase() {
            Data.deleteCase({
                id: this.delData.id,
                token: localStorage.getItem('token')
            })
                .then(json => {
                    console.log('json');
                    if (json.data.status == 'done') this.$emit('del');
                    else alert('ошибка!')
                })
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/case/deleteCase.vue